import { MessageCircle } from "lucide-react";
import { FIRM } from "../data/siteData";

export default function WhatsAppFloat() {
  const href = `https://wa.me/${FIRM.phoneRaw}?text=${encodeURIComponent(FIRM.whatsappText)}`;
  return (
    <a
      data-testid="whatsapp-float-btn"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className="group fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] shadow-xl shadow-[#25D366]/30 transition-transform duration-300 hover:scale-110"
    >
      <span className="absolute inset-0 animate-ping rounded-full bg-[#25D366]/40 [animation-duration:2.5s]" />
      <svg viewBox="0 0 24 24" className="relative h-7 w-7 fill-white">
        <path d="M17.5 14.4c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.14-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.8.37-.27.3-1.04 1.02-1.04 2.5 0 1.47 1.07 2.9 1.22 3.1.15.2 2.1 3.2 5.1 4.49.71.31 1.27.49 1.7.63.72.23 1.37.2 1.88.12.57-.09 1.76-.72 2.01-1.42.25-.7.25-1.3.17-1.42-.07-.12-.27-.2-.57-.35M12.05 21.79h-.01a9.79 9.79 0 0 1-5-1.37l-.36-.21-3.72.97.99-3.62-.23-.37a9.77 9.77 0 1 1 8.33 4.6M12.04.5A11.55 11.55 0 0 0 .48 12.03c0 2.04.53 4.03 1.55 5.78L.38 23.5l5.83-1.53a11.52 11.52 0 0 0 5.82 1.57h.01A11.55 11.55 0 0 0 23.6 12.02C23.6 5.66 18.4.5 12.04.5" />
      </svg>
    </a>
  );
}
